/* eslint-disable no-param-reassign */
export function target() {
  return this.module === 'PageSettings';
}

export function migrate() {
  const { headingId, logo } = this.data;

  if (headingId) {
    const [module, id] = headingId.split('-');

    if (logo && module === 'NewHeader') {
      this.data.headingId = `Banner-${id}`;
    }
  }
}
